import React from "react";
import {
  Box,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";
import Link from "next/link";

const HeroSection = () => {
  const theme = useTheme();
  const isSmallMobile = useMediaQuery("(max-width: 599px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: { xs: "100%", md: "1420px" },
        mx: "auto",
        px: { xs: 4, md: 4 },
        pr: { xs: 4, md: 0 },
        mt: { xs: 0, md: -5 },
        position: "relative",
      }}
    >
      {/* Text Content */}
      <Box
        sx={{
          maxWidth: { xs: "100%", md: 500 },
          textAlign: { xs: "center", md: "left" },
          mb: { xs: 4, md: 0 },
        }}
      >
        <Typography
          sx={{
            fontFamily: "var(--font-poppins)",
            fontSize: { xs: "28px", md: "50px" },
            fontWeight: 800,
            lineHeight: { xs: 1.25, md: 1.2 },
            color: theme.palette.primary.main,
            mb: { xs: 2, md: 7 },
            mt: { xs: 2, sm: 10, lg: 5, xl: 6 },
          }}
        >
          Reduce shipping costs, increase your profits
        </Typography>

        {isSmallMobile && (
          <Box sx={{ position: "relative", mt: { xs: -4 } }}>
            <Image
              src="/images/CourrierPercentages.png"
              alt="Courier Percentages"
              width={1000}
              height={460}
              style={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
              }}
            />
          </Box>
        )}
        <Typography
          sx={{
            fontFamily: "RethinkSans, sans-serif",
            fontSize: { xs: "16px", md: "18px" },
            lineHeight: { xs: 1.6, md: 1.5 },
            color: "#212529",
            maxWidth: { xs: "100%", md: 500 },
            mb: { xs: 3, md: 6 },
          }}
        >
          Nest Shipper helps you create shipping labels effortlessly while
          giving you access to discounted carrier rates. Lower your logistics
          expenses and boost your profit margins all from one simple platform.
        </Typography>

        <Stack
          direction={isSmallMobile ? "column" : "row"}
          spacing={isSmallMobile ? 2 : 4}
          justifyContent={{ xs: "center", md: "flex-start" }}
          sx={{ mb: { xs: 2, md: 10 } }}
        >
          <Link href="/sign-up" passHref>
            <Button
              variant="contained"
              color="secondary"
              sx={{ width: isSmallMobile ? "100%" : "180px", height: "48px" }}
            >
              Get Started
            </Button>
          </Link>
          <Link href="/contact-us" passHref>
            <Button
              variant="text"
              color="primary"
              sx={{ textDecoration: "underline" }}
            >
              Contact Us
            </Button>
          </Link>
        </Stack>
      </Box>

      {/* Image */}
      {!isSmallMobile && (
        <Box sx={{ position: "relative", mt: { xs: -8, md: 0 } }}>
          <Image
            src="/images/CourrierPercentages.png"
            alt="Courier Percentages"
            width={1000}
            height={460}
            style={{
              maxWidth: "100%",
              height: "auto",
              borderRadius: "8px",
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default HeroSection;
